import React from "react";
import logo from "./logo.svg";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";

import aws from "./images/aws-logo.png";
import nvidia from "./images/nvidia-logo.png";
import salesforce from "./images/salesforce-logo.png";
import intel from "./images/intel-logo.png";
import microsoft from "./images/microsoft-logo.png";
import verint from "./images/verint-logo.png";
import afiniti from "./images/afiniti-logo.png";
import googleCloud from "./images/google-cloud-logo.png";
import ibm from "./images/ibm-logo.png";
import nuance from "./images/nuance-logo.png";
import journey from "./images/Journey.png";
import cognigy from "./images/cognigy.png";
import { t } from "i18next";

import "./PartnerEcosystemScreen.scss";

function PartnerEcosystemScreen() {
  return (
    <div className="partner-ecosystem-screen-container fill-absolute">
      <div className="blue-background flex vertical-center">
        <div className="container row" style={{ justifyContent: "center" }}>
          <div className="flex">
            <h2 className="white-header">{t("Partner.title")}</h2>
            <p>{t("Partner.description")}</p>
          </div>
          <div className="spacer"></div>
          <div style={{ backgroundColor: "white", width: 1 }}></div>
          <div className="spacer mobile-spacer"></div>
          <div className="spacer"></div>
          <div className="flex">
            <p>
              {t("Partner.description2")}
            </p>
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="container logosContainer">
          <div className="logoContainer">
            <img src={aws} alt="aws logo" />
          </div>

          <div className="logoContainer">
            <img src={nvidia} alt="nvidia logo" />
          </div>
          <div className="logoContainer">
            <img src={salesforce} alt="salesforce logo" />
          </div>
          <div className="logoContainer">
            <img src={intel} alt="intel logo" />
          </div>
          <div className="logoContainer">
            <img src={journey} alt="journey logo" />
          </div>
          <div className="logoContainer">
            <img src={cognigy} alt="cognigy logo" />
          </div>
          <div className="logoContainer">
            <img src={verint} alt="verint logo" />
          </div>
          <div className="logoContainer">
            <img src={afiniti} alt="afiniti logo" />
          </div>
          <div className="logoContainer">
            <img src={googleCloud} alt="google cloud logo" />
          </div>
          <div className="logoContainer">
            <img src={ibm} alt="ibm logo" />
          </div>
          <div className="logoContainer">
            <img src={nuance} alt="nuance logo" />
          </div>
          <div className="logoContainer">
            <img src={microsoft} alt="microsoft logo" />
          </div>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton
          to="/capabilities-insights-analytics"
          side="left"
        ></ArrowButton>
        <ArrowButton to="/explore" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default PartnerEcosystemScreen;
